<template>
  <div class="cascsder-wrapper" :class="{ age: isAgeStyle }">
    <div class="picker-wrap">
      <picker
        :ref="pickerRef"
        item-height="46"
        visible-item-count="10"
        class="picker"
        :columns="columns"
        value-key="content"
        title="选择地区"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Picker from 'vant/lib/picker';
import 'vant/lib/picker/style';
import { IQuestion, IAnswerItem, IOption, CascaderType } from './types';

interface IBaseInfo {
  content: string; // 选项文字，用于组件渲染
  code: string; // 选项code，用于后端数据提交
  children?: IBaseInfo[]; // 用于组件渲染子列
}

@Component({
  components: { Picker },
})
export default class Cascader extends Vue {
  @Prop({}) data!: IQuestion;
  @Prop({}) answer!: IAnswerItem;

  columns: IBaseInfo[] = [];
  activeIndex = [0, 0];

  get isAgeStyle() {
    return this.data && this.data.specType === CascaderType.birth;
  }

  get pickerRef() {
    return `picker-${this.data.code}`;
  }

  get defaultParentIndex() {
    if (this.isAgeStyle) {
      return 7; // 默认选中90后，该选项一般情况下不会改变，so ... hardcode
    } else {
      return 0;
    }
  }

  mounted() {
    this.initColumns();

    this.handleInitAnswer();
  }

  initColumns() {
    // 构造出 IBaseInfo 结构
    const columns: IBaseInfo[] = [];
    this.data.options.forEach((option) => {
      columns.push(this.generateData(option, true /* isLoop */));
    });
    this.columns = columns;
  }
  handleInitAnswer() {
    let parentIndex = -1;
    let childIndex = -1;

    try {
      // this.answer可能为undefined，此时被catch，不执行遍历查询
      const [parentCode, childCode] = this.answer.codeList!;

      parentIndex = this.columns.findIndex((item) => item.code === parentCode);
      if (parentIndex && parentIndex >= 0) {
        if (!childCode) {
          childIndex = 0;
        } else {
          const _childIndex = this.columns[parentIndex].children?.findIndex(
            (item) => item.code === childCode
          );
          _childIndex && (childIndex = _childIndex);
        }
      }
    } catch (e) {}

    if (!(parentIndex >= 0 && childIndex >= 0)) {
      parentIndex = this.defaultParentIndex;
      childIndex = 0;
    }
    this.$nextTick(() => {
      this.$refs[this.pickerRef].setIndexes([parentIndex, childIndex]);
      this.onChange();
    });
  }

  generateData(
    {
      content,
      code,
      options,
    }: {
      content: string;
      code: string;
      options: IOption[];
    },
    loop = false
  ) {
    const result: IBaseInfo = {
      content,
      code,
    };
    if (loop) {
      if (options && Array.isArray(options)) {
        result.children = options.map((item) => this.generateData(item));
      } else {
        result.children = [{ content: '', code: '' }];
      }
    }
    return result;
  }

  onChange() {
    this.$emit(
      'onChooseCascader',
      this.data,
      this.$refs[this.pickerRef].getValues()
    );
  }
}
</script>

<style lang="scss" vars="{ques-theme-bg}">
$theme-color: var(--ques-theme-bg);

.cascsder-wrapper {
  width: 100vw;
  padding: 0 42px;
  .picker-wrap {
    max-height: 60vh;
    overflow: hidden;
  }

  .picker {
    transform: translateY(-100px);
  }
  .van-picker__columns {
    .van-picker__frame {
      // width: 666px;
      // height: 94px !important;
      background: linear-gradient(
        270deg,
        rgba(102, 95, 148, 0) 0%,
        $theme-color 51%,
        rgba(104, 84, 240, 0) 100%
      );
      opacity: 0.12;
    }

    // 职业
    .van-picker-column:nth-child(1) {
      flex: 1.2;
      // flex: 1;
    }
    .van-picker-column:nth-child(2) {
      // padding-left: 50px;
      flex: 1;
    }
    .van-picker-column__item {
      justify-content: flex-start;
      // height: 94px !important;
    }
    .van-picker-column__item--selected {
      color: $theme-color;
      // z-index: 1000;
      // transform: translateZ(1px);
      font-weight: 500;
    }
  }
}
.cascsder-wrapper.age {
  .van-picker__columns {
    padding: 0 100px; // age

    .van-picker-column:nth-child(1) {
      flex: 1;
    }
    .van-picker-column:nth-child(2) {
      // padding-left: 50px;
      flex: 1;
    }
    .van-picker-column__item {
      justify-content: center;
      // height: 94px !important;
    }
  }
}
</style>
